import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ISimulation } from '@obvious.tech/constellation'

export const Simulation = defineEntity('Simulation', {
  endpoint: 'simulator/api/Simulation',
  schema: SNoop<ISimulation>(),
})
